import { PostBoInvestorProfileEndpoint } from '@Common/types/bo/b2b/investor_profile';

import { InvestorProfileGridInstrumentAllocation } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileGrid/helpers/transformBoGridToFormGrid';

export const transformFormGridToBoGrid = (
  grid?: InvestorProfileGridInstrumentAllocation[],
): PostBoInvestorProfileEndpoint['Client']['RequestBody']['allocations'] => {
  const tmpGrid: PostBoInvestorProfileEndpoint['Client']['RequestBody']['allocations'] = [];

  const maxGridYear = grid?.at(0)?.allocation.length ?? 0;

  for (let year = 0; year < maxGridYear; year++) {
    const tmpInstrumentAllocPerYear: PostBoInvestorProfileEndpoint['Client']['RequestBody']['allocations'][number]['allocation_instruments'] =
      [];
    grid?.forEach((instrumentAllocation) => {
      tmpInstrumentAllocPerYear.push({
        instrument_id: instrumentAllocation.instrument_id,
        allocation_percent: instrumentAllocation.allocation[year],
      });
    });
    tmpGrid.push({
      min_years_to_retirement: maxGridYear - (year + 1),
      allocation_instruments: tmpInstrumentAllocPerYear,
    });
  }

  return tmpGrid.reverse();
};
